import { BASE } from "./index";
import axios from "./http";

const bi = {
  // 爆品商品销量列表
  getHotSkuSalesVolumeStatistics: (params) =>
    axios.post(`${BASE.PRO1}/getHotSkuSalesVolumeStatistics`, params),
  // 爆品商品销量导出
  getHotSkuSalesVolumeStatisticsExport: (params) =>
    axios.post(
      `${BASE.EXPORT_CENTER}/bi/getHotSkuSalesVolumeStatisticsExport`,
      params
    ),
  // 爆品标签设置记录列表
  getHotSkuRecord: (params) =>
    axios.post(`${BASE.PRO1}/getHotSkuRecord`, params),
  // 爆品标签设置记录导出
  getHotSkuRecordExport: (params) =>
    axios.post(`${BASE.EXPORT_CENTER}/bi/getHotSkuRecordExport`, params),
};
export default bi;
